const Form = {
  baseStyle: {
    requiredIndicator: {
      color: "feedback.negative.100"
    }
  },
};

export default Form;
